<template>
  <div class="page-wrapper">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <success-modal
      :show="showSuccessPopup"
      @close="closeSuccessPopup"
      :msg="'You have successfully added the shipment.'"
      :heading="'Shipment Added!'"
    />

    <AddContainerModal
      :show="showAddContainer"
      :onCancel="closeAddContainer"
      @add-container="addContainer"
      @edit-container="updateEditContainer"
      v-if="showAddContainer"
      :containers="containers"
      :containerData="container"
      :devicesByStatus="devicesByStatus"
    />

    <div class="page-breadcrumb">
      <div class="row">
        <div class="col-md-5 align-self-center mb-2">
          <h6 class="font-16 font-weight-bold">
            {{ $t("add-shipment") }}
          </h6>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="card">
        <div class="card-body add-dispatch-container">
          <div class="mb-3">
            <Stepper class="custom-page" :step="step" :labels="labels" />
          </div>
          <div class="d-flex align-items-center justify-content-between mb-4">
            <p class="font-bold">
              {{ currentStep }}
            </p>
            <div
              class="cursor-pointer d-flex justify-content-center align-items-center"
              @click="handleAddBtn"
              v-if="showAddBtn"
            >
              <icon-circle-add class="mr-2" />
              <span class="text-primary text-capitalize">
                {{ step === 2 ? $t("add_container") : null }}
              </span>
            </div>
          </div>
          <ShipmentDetailsStep
            v-if="step === 1"
            ref="ShipmentDetailsStep"
            :shipmentDetailss="shipmentDetails"
          />
          <ContainerDetails
            @showAddContainerModal="openAddContainer"
            :containers="containers"
            @edit_container="editContainer"
            @delete_container="deleteContainer"
            v-if="step === 2"
          />
          <OriginDestinationStep
            v-if="step === 3"
            ref="originDestinationStep"
            :originProp="origin"
            :destinationProp="destination"
            :shipmentDetails="shipmentDetails"
          />
          <Summary
            v-if="step === 4"
            @goToStep="goToStep"
            :origin="origin"
            :destination="destination"
            :shipmentDetails="shipmentDetails"
            :containers="containers"
            @delete_containerDetails="deleteContainer"
          />
          <div
            class="d-flex align-items-start justify-content-end col-gap-1 pt-4"
          >
            <button class="btn btn-secondary text-capitalize" @click="goBack">
              {{ $t("back_") }}
            </button>

            <button @click="goNext" class="btn btn-primary">
              {{ step === 4 ? $t("done") : $t("next") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Stepper from "../../../components/Stepper.vue";
import OriginDestinationStep from "./OriginDestinationStep.vue";
import ContainerDetails from "./ContainerDetails.vue";
import ShipmentDetailsStep from "./ShipmentDetailsStep.vue";
import Summary from "./Summary.vue";
import { mapActions, mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import SuccessModal from "../../Modals/SuccessModal.vue";

import AddContainerModal from "../../Modals/AddContainerModal.vue";

import IconCircleAdd from "../../../components/Iconsvg/IconCircleAdd.vue";

import loadGoogleMapsApi from "load-google-maps-api";

export default {
  name: "AddShipment",
  components: {
    Stepper,
    ShipmentDetailsStep,
    OriginDestinationStep,
    Summary,
    Loading,
    SuccessModal,
    ContainerDetails,
    AddContainerModal,
    IconCircleAdd,
  },

  data() {
    return {
      step: 1,
      labels: ["Shipment", "Container", "Origin/Destination", "Summary"],
      origin: {},
      destination: {},
      shipmentDetails: {},
      isLoading: false,
      showSuccessPopup: false,
      fullPage: true,
      showAddContainer: false,
      containers: [],
      container: {},
    };
  },
  computed: {
    ...mapGetters(["devicesByStatus"]),

    showAddItemBtn() {
      return this.step === 2 && this.containers.length > 0;
    },
    showAddBtn() {
      return this.showAddItemBtn;
    },
    currentStep() {
      let stepTitle = "";
      switch (this.step) {
        case 2:
          stepTitle = "Container";
          break;
        case 3:
          stepTitle = "Origin/Destination";
          break;
        case 4:
          stepTitle = "Summary";
          break;
        default:
          stepTitle = "Shipment Details";
          break;
      }
      return stepTitle;
    },
  },

  methods: {
    ...mapActions([
      "getOrigin",
      "getDestinations",
      "addShipment",
      "fetchallDevices",
      "getDevicesByStatus",
    ]),
    handleAddBtn() {
      if (this.showAddItemBtn) {
        this.openAddContainer();
      }
    },
    openAddContainer() {
      this.showAddContainer = true;
      this.container = {};
    },
    closeAddContainer() {
      this.showAddContainer = false;
      this.id = null;
      this.container = {};
    },
    addContainer(container) {
      const id = this.containers.length + 1;
      this.container = { ...container, id };

      this.showAddContainer = false;
      this.id = id;
      this.containers.push({ ...container, id });

      console.log("container:", this.containers, "id", id);
    },
    editContainer(container) {
      this.showAddContainer = true;
      this.container = { ...this.container, ...container };
    },
    deleteContainer(index) {
      this.containers.splice(index, 1);
      console.log("deleted");
    },
    updateEditContainer(container) {
      console.log("Original container:", this.container);
      this.container = { ...this.container, ...container };
      console.log("Updated container:", this.container);

      console.log("Container ID to update:", this.container.id);
      console.log(
        "All container IDs:",
        this.containers.map((c) => c.id)
      );

      const index = this.containers.findIndex(
        (c) => c.id === this.container.id
      );
      console.log("Container index:", index);

      if (index !== -1) {
        this.$set(this.containers, index, {
          ...this.containers[index],
          ...container,
        });
        console.log("Updated containers array:", this.containers);
      }

      this.showAddContainer = false;
    },
    goNext() {
      if (this.step === 1) {
        const isValid = this.$refs.ShipmentDetailsStep.validateForm();
        if (isValid) {
          this.shipmentDetails = this.$refs.ShipmentDetailsStep.getFormData();
          this.step++;
        }
        return;
      }
      if (this.step === 2 && this.containers.length >= 1) {
        this.step++;
        return;
      }
      if (this.step === 3) {
        const isValid = this.$refs.originDestinationStep.validateForm();
        if (isValid) {
          const {
            origin,
            destination,
          } = this.$refs.originDestinationStep.getFormData();
          this.origin = origin;
          this.destination = destination;
          this.step++;
        }
        return;
      }
      if (this.step === 4) {
        const payload = {
          ...this.shipmentDetails,
          containers: this.containers.map((container) => ({
            pallet: container.pallet,
            product: container.product,
            containerNumber: container.containerNumber,
            assignedDevices: container.assignedDevices.map(
              (device) => device.id
            ),
          })),

          origin: this.origin.id ? this.origin.id : undefined,
          originInfo: !this.origin.id ? this.origin : undefined,

          destination: this.destination.id ? this.destination.id : undefined,
          destinationInfo: !this.destination.id
            ? {
                address:
                  {
                    name: this.shipmentDetails.pointOfArrival,
                    lat: this.shipmentDetails.lat,
                    lng: this.shipmentDetails.lng,
                  } ||  {
                    name: this.destination.address.name,
                    lat: this.destination.address.lat,
                    lng: this.destination.address.lng,
                  } ,
                country: this.destination.country || "",
                name: this.destination.name || "",
                personOfContact: this.destination.personOfContact || "",
                region: this.destination.region || "",
              }
            : undefined,

          pointOfArrivalPoint:
            !this.destination.id &&
            this.shipmentDetails.lat &&
            this.shipmentDetails.lng
              ? {
                  lat: this.shipmentDetails.lat,
                  lng: this.shipmentDetails.lng,
                }
              : undefined,
          // assignedDevices: this.container.assignedDevices.map(
          //   (device) => device.id
          // ),
        };
        this.isLoading = true;
        this.addShipment(payload)
          .then(() => {
            this.isLoading = false;
            this.showSuccessPopup = true;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },

    goBack() {
      if (this.step === 3) {
        const {
          origin,
          destination,
        } = this.$refs.originDestinationStep.getFormData();
        this.origin = origin;
        this.destination = destination;
        return this.step--;
      }
      if (this.step > 1) {
        this.step--;
      } else {
        this.$router.push("/export/dispatch");
      }
    },
    goToStep(step) {
      this.step = step;
    },
    closeSuccessPopup() {
      this.showSuccessPopup = false;
      this.$router.push("/export/dispatch");
    },
  },
  mounted() {
    this.getDevicesByStatus({ status: "ongoing" });

    this.getOrigin();
    this.getDestinations();
    this.fetchallDevices();

    loadGoogleMapsApi({
      key: process.env.VUE_APP_GOOGLE_API_KEY,
      libraries: ["places", "drawing", "geometry"],
    });
  },
};
</script>

<style scoped>


@media (min-width: 540px) {
.custom-page >>> .stepper p:nth-child(2) {
 margin-left: 2rem;
}
}

.page-wrapper > .container-fluid {
  margin-top: 0;
}

.card-body {
  padding: 2rem;
}
</style>
